// Hide back button on colelctions page
var url = window.location.href;
var lastPart = url.substr(url.lastIndexOf('/') + 1);

if (lastPart === "test-collection-barcode-scanning") { // If the last part of the url is...
  	// Add hide class to the back button
   	jQuery(".collection-page .subnav .back").addClass("display-none")
}